<div class="video-page-container">
    <div class="video-frame">
        <dyte-meeting #meeting show-setup-screen="true"></dyte-meeting>
    </div>
</div>
